import React from "react";
import type { BoardProps } from "../pages/room";
import { t } from "../i18n";
import { cx } from "../ui";
import { SEAT_COLORS } from "./colors";

const SHAPES = ["circle", "square", "triangle", "diamond", "star", "moon"] as const;
const FACE_COLORS = ["#FF6B5B", "#2ED3B7", "#F7B32B", "#8C7CFF"];

function Face({ face }: { face: number }) {
  const shape = SHAPES[face % SHAPES.length];
  const c = FACE_COLORS[Math.floor(face / SHAPES.length) % FACE_COLORS.length];
  const p: Record<string, React.ReactNode> = {
    circle: <circle cx="20" cy="20" r="11" fill={c} />,
    square: <rect x="9" y="9" width="22" height="22" rx="3" fill={c} />,
    triangle: <path d="M20 7l13 24H7z" fill={c} />,
    diamond: <path d="M20 6l13 14-13 14L7 20z" fill={c} />,
    star: <path d="M20 6l4 9 10 1-7 7 2 10-9-5-9 5 2-10-7-7 10-1z" fill={c} />,
    moon: <path d="M24 8a13 13 0 1 0 7 20A10 10 0 1 1 24 8z" fill={c} />,
  };
  return <svg viewBox="0 0 40 40" aria-hidden="true">{p[shape]}</svg>;
}

export function MemoryBoard({ view, names, myTurn, move }: BoardProps) {
  const cols = view.cards.length <= 16 ? 4 : 6;
  return (
    <div className="memory">
      <div className="memory-scores">
        {view.scores.map((s: number, i: number) => (
          <span key={i} className={cx(i === view.turn && "is-turn")} style={{ borderColor: SEAT_COLORS[i] }}>
            {names[i]}: <b>{s}</b> {t.pairsFound}
          </span>
        ))}
      </div>
      <div className="memory-grid" style={{ gridTemplateColumns: `repeat(${cols}, 1fr)` }}>
        {view.cards.map((f: number | null, i: number) => {
          const open = f !== null;
          const ownerSeat = view.owner[i];
          const can = myTurn && !open;
          return (
            <button
              key={i}
              className={cx("mem-card", open && "is-open", ownerSeat >= 0 && "is-matched", view.lastMismatch.includes(i) && "is-miss")}
              style={ownerSeat >= 0 ? { borderColor: SEAT_COLORS[ownerSeat] } : undefined}
              disabled={!can}
              onClick={() => move({ type: "flip", index: i })}
              aria-label={open ? String(f) : `#${i + 1}`}
            >
              {open ? <Face face={f!} /> : <img src="/brand/samra-symbol-mono-light.svg" alt="" />}
            </button>
          );
        })}
      </div>
      {!myTurn && <p className="hint center">{t.turnOf(names[view.turn] ?? "")}</p>}
    </div>
  );
}
